import {IntlShape} from 'react-intl';

export class FlashyHelper {
  public static dogOwnerText(dogOwner: boolean, intl: IntlShape) {
    return dogOwner
      ? intl.formatMessage({id: 'flashy-dogOwner-message-yes', defaultMessage: 'yes'})
      : intl.formatMessage({id: 'flashy-dogOwner-message-no', defaultMessage: 'no'});
  }
}